var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00003 14C2.00003 8.47715 6.47718 4 12 4C14.6522 4 17.1957 5.05357 19.0711 6.92893C20.9465 8.8043 22 11.3478 22 14C22.005 15.9806 21.4163 17.9172 20.31 19.56C20.1238 19.8356 19.8127 20.0005 19.48 20C19.2806 20.0004 19.0856 19.9412 18.92 19.83C18.6996 19.6817 18.5473 19.4518 18.4966 19.191C18.446 18.9302 18.5012 18.66 18.65 18.44C20.8822 15.1022 20.2942 10.6268 17.2756 7.97879C14.257 5.33082 9.7431 5.33082 6.72447 7.97879C3.70584 10.6268 3.11785 15.1022 5.35003 18.44C5.65931 18.8984 5.53843 19.5207 5.08003 19.83C4.62163 20.1393 3.99931 20.0184 3.69003 19.56C2.58375 17.9172 1.99511 15.9806 2.00003 14ZM12.51 13.07L15.29 10.29C15.6822 9.89788 16.3179 9.89788 16.71 10.29C17.1022 10.6821 17.1022 11.3179 16.71 11.71L13.93 14.49C13.9743 14.6565 13.9978 14.8278 14 15C14 16.1046 13.1046 17 12 17C11.8278 16.9978 11.6565 16.9743 11.49 16.93L10.71 17.71C10.5223 17.8993 10.2667 18.0058 10 18.0058C9.73339 18.0058 9.4778 17.8993 9.29003 17.71C9.10072 17.5222 8.99423 17.2666 8.99423 17C8.99423 16.7334 9.10072 16.4778 9.29003 16.29L10.07 15.51C10.0258 15.3435 10.0023 15.1722 10 15C10 13.8954 10.8955 13 12 13C12.1723 13.0022 12.3436 13.0257 12.51 13.07Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDashboard);
export default ForwardRef;